import AOS from 'aos';
import 'aos/dist/aos.css'; // You can also use <link> for styles

function aosInit() {
	AOS.init({once: true, duration: 400});
}

export default aosInit;
